import { render, staticRenderFns } from "./ModalBase.vue?vue&type=template&id=88040d3a"
import script from "./ModalBase.vue?vue&type=script&lang=js"
export * from "./ModalBase.vue?vue&type=script&lang=js"
import style0 from "./ModalBase.vue?vue&type=style&index=0&id=88040d3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports